module.exports = __webpack_public_path__ + "img/realcase-detail.a5279452.png";